import React from "react";
import Button from "react-bootstrap/Button";
import { useNavigate } from "react-router-dom";

const CheckoutButton = () => {
  const navigate = useNavigate();

  const handleCheckout = () => {
    navigate("/checkout"); // Navigate to the checkout page
  };

  return (
    <Button onClick={handleCheckout} className="checkout-button">
      Checkout
    </Button>
  );
};

export default CheckoutButton;
